
<app-content-render-sections *ngIf="!!article &amp;&amp; !!article.sections" [sections]="article.sections" [mode]="mode" [lockedCallback]="lockedCallback" [accessLevel]="accessLevel"></app-content-render-sections>